<template>
  <div v-if="isVisible" class="modal_overlay" @click="closeModal">
    <transition name="modal-fade">
      <div class="modal" :style="{ width: modalWidth }" @click.stop>
        <div class="modal_header">
          <h1 class="modal_title">{{ title }}</h1>
          <img :src="imagePath.closeIcon" alt="close_icon" class="size-4 cursor-pointer" @click="closeModal" />
        </div>
        <div class="modal_body">
          <slot></slot>
        </div>
        <div class="modal_footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import imagePath from '@/javascript/imagePath';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: '400px',
  },
});

const emit = defineEmits(['update:visible']);

const isVisible = ref(props.visible);
const modalWidth = ref(props.width);

watch(
  () => props.visible,
  (newVal) => {
    isVisible.value = newVal;
  }
);

watch(
  () => props.width,
  (newVal) => {
    modalWidth.value = newVal;
  }
);

const closeModal = () => {
  isVisible.value = false;
  emit('update:visible', false);
};
</script>

<style scoped>
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: var(--color-white);
  border-radius: 8px;
  max-width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  color: white;
  transform: translateY(0);
  opacity: 1;
  transition:
    transform 0.3s ease-out,
    opacity 0.3s ease-out;
}

.modal_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-light-gray);
  padding: 16px;
}

.modal_title {
  color: var(--foreground-rgb);
  font-family: 'Proxima Nova', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.modal_body {
  padding: 24px 16px;
  gap: 24px;
}

.modal_footer {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--color-light-gray);
  padding: 16px;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
